// extracted by mini-css-extract-plugin
export default {"section":"SectionImage_section__hZnEv","container":"SectionImage_container__zPumj","credit":"SectionImage_credit__nkT5t"};